// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1tN9z","divider":"style_divider__3wTbd"};